import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AppRootRoute } from '@core/enums/app-route.enum';
import { ProfileService } from '@core/services/profile.service';

@Injectable({
  providedIn: 'root',
})
export class UserActiveGuard {
  constructor(
    private readonly profileService: ProfileService,
    private readonly router: Router
  ) {}

  canActivate(): boolean {
    if (this.profileService.getUserActiveState()) {
      this.router.navigate([AppRootRoute.HOME]);
    }

    return !this.profileService.getUserActiveState();
  }

  canMatch(): boolean {
    return !this.profileService.getUserActiveState();
  }
}
